import styled from "styled-components";

export const LoadingInputContainer = styled.div`
    border: 1px solid var(--color-grey-700);
    border-radius: var(--radius-5);
    width: 100%;
    display: inline-flex;
    box-sizing: border-box;
    min-height: 4rem;
    align-items: center;
    line-height: 1.9rem;
    justify-content: center;
`;
